
const validate = require("validate.js");

export default () => ({

    errors: {},

    validationConstraints: {
        email: {
            presence: {
                allowEmpty: false,
                message: "^ Wat is je E-mailadres?"
            },
            email: true
        },
        terms: {
            presence: {
                message: "^Ga je akkoord met onze voorwaarden?"
            },
            inclusion: {
                within: [true],
                message: "^Ga je akkoord met onze voorwaarden?"
            }
        }
    },

    validate(){

        var formData = new FormData(this.$root);

        var attributes = {
            email: formData.get('email'),
            terms: (formData.get('fields[acceptedTerms]')) ? true : false
        };

        let errors = validate(attributes, this.validationConstraints);

        this.errors = (errors) ? errors : {};

        if(!errors) {
            return true;
        }

        return false;
    },

    handleSubmit(e){

        if(!this.validate()){
            e.preventDefault();
        }
    }

});
